module.exports = __webpack_public_path__ + "static/media/Industries.d45bae6e.png";